module.exports = __webpack_public_path__ + "static/media/t-shirts.edbbc564.svg";